import React from "react";
import { Marker } from "react-leaflet";
import { parking } from "../Icons/icons";

/*
 * This component displays the parking markers on the map
 */

const Parking = (props: { spots: any }) => {
  return (
    <div>
      {props.spots &&
        props.spots.reduce((acc, spot) => {
          return [
            ...acc,
            ...spot.gps.map((gps) => {
              return (
                <Marker
                  key={`parking-${spot.name}-${gps.lat}-${gps.long}`}
                  position={{ lat: gps.lat, lng: gps.long }}
                  icon={parking}
                />
              );
            }),
          ];
        }, [])}
    </div>
  );
};

export default Parking;
